module.exports = __webpack_public_path__ + "img/macbook-platform-tway.a8fda2cc.jpeg";